function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}

export default function() {
  return this.each(remove);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selection/remove.js
// module id = 1647
// module chunks = 0